// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./hooks/useAuth";
import Layout from "./layout/Layout";
import About from "./pages/About";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Users from "./pages/Users";
import "antd/dist/reset.css";
import "./index.css";
import Legal from "./pages/Legal";

// ✅ Define all routes directly here (data router style)
const router = createBrowserRouter(
  [
    {
      path: "/login",
      element: <Login />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorBoundary />, // Built-in error handling
      children: [
        { index: true, element: <Home /> }, // default route
        { path: "users", element: <Users /> },
        { path: "about", element: <About /> },
        { path: "legal", element: <Legal /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true, // ✅ Opt-in early to React 18 concurrent transitions
    },
  }
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
